import { EqualContentJustfy } from "../../../../libraries/ReportGenerator/EqualContentJustify";
import { TickBox, TickMark } from "../../../../libraries/ReportGenerator/TickBox";
import { dataFormatters } from "../../../../utils/dataFormatters";
import React from "react";

const headerInlineStyle1 = {
  fontSize: "12px",
};
const headerInlineStyle2 = {
  fontSize: "12px",
  wordBreak: "break-word",
};

export const SFRTA_TracksRemovedFromServiceFormOReportSchema = {
  sections: [

    {
      heights: {
        header1: "auto",
      },
      headerOnly: true,
      classes: {
        header1: "grey-background",
      },
      columns: [
        {
          title: "TRACKS REMOVED FROM SERVICE - FORM O",
          colSpan: 26,
          rowSpan: 1,
          className: "tbl-text-normal",
        },
      ],
    },
    {
      heights: {
        header1: "auto",
      },
      inlineData: true,
      columns: [
        {
          title: "NAME",
          colSpan: 26,
          rowSpan: 1,
          className: "tbl-text-normal",
          leftAlign: true,
          accessor: 'name'
        },
      ],
    },
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      inlineStyle: {
        header1: headerInlineStyle1,
        header2: headerInlineStyle2,
      },
      minDataRowsCount: 3,
      columns: [
        {
          title: "DATE",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'date',
          formatter: dataFormatters.dateFormatter
        },
        {
          title: "AUTHORITY NO.",
          colSpan: 3,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'authno'
        },
        {
          title: "TRACK(S)",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'track'
        },
        {
          title: "LIMITS",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "BETWEEN",
              colSpan: 3,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'lbet1'
            },
            {
              title: "BETWEEN",
              colSpan: 3,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'lbet2'
            },
          ],
        },
        {
          title: "EXPIRES",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'exp',
          formatter: dataFormatters.convert24HourFormattedTimeToAMPM
        },
        {
          title: "\"OK\" TIME",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'oktime',
          formatter: dataFormatters.convert24HourFormattedTimeToAMPM
        },
        {
          title: "DISP. INITIALS",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'dispinit'
        },
        {
          title: "MP RED FLAG",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'no1'
        },
        {
          title: "MP RED FLAG",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: 'no2'
        },
        {
          title: "EQUIPMENT / TRAIN IN LIMITS",
          colSpan: 6,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "TRAIN",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'train',
            },
            {
              title: "NAME",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'name1'
            },
            {
              title: "TIME IN",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'timein',
              formatter: dataFormatters.convert24HourFormattedTimeToAMPM
            },
            {
              title: "TIME CLR",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: 'tclr',
              formatter: dataFormatters.convert24HourFormattedTimeToAMPM
            },
          ],
        },
      ],
    },
    {
      heights: {
        header1: "auto",
      },
      classes: {
        header1: "grey-background",
      },
      columns: [
        {
          title: "JOB BRIEFING CHECKLIST",
          colSpan: 26,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: ['atlp', 'fak', 'wcond', 'jsite'],
          dontJoinValues: true,
          formatter: (values) => {
            const titles = ["ADJACENT TK/LOCATION OF PPS", "FIRST AID KIT", "WEATHER CONDITIONS", "JOB SITE SIGN IN/OUT"];
            const vals = values && Array.isArray(values) ? values : [null, null, null, null];
            return <div style={{ padding: '10px 0px' }}>
              <EqualContentJustfy fontSize={'15px'}>
                {vals.map((value, i) => <TickBox flag={value} label={titles[i]} style={{ flex: '25%' }} />)}
              </EqualContentJustfy>
            </div>
          }
        },
      ],
    },
    {
      heights: {
        header1: "auto",
      },
      classes: {
        header1: "grey-background",
      },
      minDataRowsCount: 1,
      columns: [
        {
          title: 'NOTES',
          colSpan: 26,
          rowSpan: 1,
          className: "tbl-text-normal",
          leftAlign: true,
          accessor: 'notes',
          dataClassName: "text-left pd-left-10px d-block"
        },
      ],
    },
  ],
};


// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/TracksRemovedFromServiceFormO/SFRTA_TracksRemovedFromServiceFormOReportSchema.js